var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9152 17.9891L7.84276 17.8964C6.20042 17.864 4.55399 17.9286 2.94384 17.5936C0.49445 17.0933 0.320926 14.6398 0.139351 12.5818C-0.11084 9.68848 -0.0139833 6.74266 0.458159 3.87352C0.7247 2.26362 1.77364 1.30299 3.3958 1.19845C8.87176 0.81908 14.3841 0.86404 19.848 1.04103C20.425 1.05726 21.006 1.14594 21.575 1.24688C24.3837 1.73921 24.4522 4.51955 24.6343 6.86008C24.8159 9.22476 24.7392 11.6016 24.3922 13.9501C24.1137 15.8947 23.581 17.5254 21.3329 17.6828C18.5161 17.8887 15.764 18.0544 12.9393 18.0016C12.9395 17.9891 12.9232 17.9891 12.9152 17.9891ZM9.93309 13.0661C12.0558 11.8473 14.1379 10.6489 16.2484 9.43829C14.1218 8.21953 12.0436 7.02109 9.93309 5.81052V13.0661Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector (2).7f2f5c1b273f0c71061d67740cd64a62.svg";
export { ForwardRef as ReactComponent };